var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient-view overview"},[(_vm.filter)?_c('FilterCard',{attrs:{"edit":true,"filter":_vm.filterData}}):_vm._e(),(_vm.print)?_c('FacesheetCard',{attrs:{"population":_vm.population,"print":_vm.print}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }